/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskUpdateRequestTitle } from './taskUpdateRequestTitle';
import type { TaskUpdateRequestDescription } from './taskUpdateRequestDescription';
import type { TaskUpdateRequestAnalysis } from './taskUpdateRequestAnalysis';
import type { TaskUpdateRequestRubric } from './taskUpdateRequestRubric';
import type { TaskUpdateRequestEvaluation } from './taskUpdateRequestEvaluation';
import type { TaskUpdateRequestType } from './taskUpdateRequestType';
import type { TaskUpdateRequestSortIndex } from './taskUpdateRequestSortIndex';
import type { TaskUpdateRequestEventConfig } from './taskUpdateRequestEventConfig';
import type { TaskUpdateRequestRecursiveUpdateCourses } from './taskUpdateRequestRecursiveUpdateCourses';

/**
 * Update a Task
 */
export interface TaskUpdateRequest {
  title?: TaskUpdateRequestTitle;
  description?: TaskUpdateRequestDescription;
  analysis?: TaskUpdateRequestAnalysis;
  rubric?: TaskUpdateRequestRubric;
  evaluation?: TaskUpdateRequestEvaluation;
  type?: TaskUpdateRequestType;
  sortIndex?: TaskUpdateRequestSortIndex;
  eventConfig?: TaskUpdateRequestEventConfig;
  recursiveUpdateCourses?: TaskUpdateRequestRecursiveUpdateCourses;
}
